export default "__VITE_ASSET__v4wVWTkJ__"